var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getPaginationDataIsolated, getPaginationOffsetData, } from 'store/commonReducer/common.action';
import { PaginationSearchProvider } from './PaginationSearchContext';
import SearchContainer from './SearchContainer';
import PaginationContainer from './PaginationContainer';
import { PaginationFetchTypes } from 'globals/enums';
import PaginationOffsetContainer from './PaginationOffsetContainer';
import { useAppDispatch } from 'hooks/reduxHooks';
/**
 * @description HOC to provide pagination in tables
 * @param {any} WrappedComponent component
 * @param {Object} componentProps props of wrapped component
 * @param {IWithPaginationProps} withPaginationProps props of HOC
 * @returns {JSX.Element} JSX
 */
var withPaginationTable = function (WrappedComponent, componentProps, withPaginationProps, withPaginationPropsRef) {
    var WithPaginationSearch = function () {
        var _a, _b;
        var dispatch = useAppDispatch();
        var currentProps = (_a = withPaginationPropsRef === null || withPaginationPropsRef === void 0 ? void 0 : withPaginationPropsRef.current) !== null && _a !== void 0 ? _a : withPaginationProps;
        var dependency = (_b = currentProps === null || currentProps === void 0 ? void 0 : currentProps.dependency) !== null && _b !== void 0 ? _b : true;
        React.useEffect(function () {
            var _a;
            if (!dependency)
                return;
            var fetchData = function () {
                var _a, _b, _c, _d, _e;
                var effectProps = (_a = withPaginationPropsRef === null || withPaginationPropsRef === void 0 ? void 0 : withPaginationPropsRef.current) !== null && _a !== void 0 ? _a : currentProps;
                if (effectProps.fetchType === PaginationFetchTypes.OFFSET) {
                    var paginationOffsetProps = effectProps.paginationOffsetProps;
                    var sessionKey_1 = (_b = effectProps.searchBarProps) === null || _b === void 0 ? void 0 : _b.sessionKey;
                    var rawSearchTerm_1 = sessionKey_1
                        ? sessionStorage.getItem(sessionKey_1)
                        : '';
                    var initialSearchTerm_1 = (_c = rawSearchTerm_1 === null || rawSearchTerm_1 === void 0 ? void 0 : rawSearchTerm_1.trim()) !== null && _c !== void 0 ? _c : '';
                    dispatch(getPaginationOffsetData(paginationOffsetProps === null || paginationOffsetProps === void 0 ? void 0 : paginationOffsetProps.getData, paginationOffsetProps === null || paginationOffsetProps === void 0 ? void 0 : paginationOffsetProps.rowsPerPage, 1, 0, paginationOffsetProps === null || paginationOffsetProps === void 0 ? void 0 : paginationOffsetProps.limit, paginationOffsetProps === null || paginationOffsetProps === void 0 ? void 0 : paginationOffsetProps.onSuccess, paginationOffsetProps === null || paginationOffsetProps === void 0 ? void 0 : paginationOffsetProps.onError, [], initialSearchTerm_1 || undefined, paginationOffsetProps === null || paginationOffsetProps === void 0 ? void 0 : paginationOffsetProps.onSearchSuccess));
                    return;
                }
                var paginationProps = effectProps.paginationProps, searchBarProps = effectProps.searchBarProps;
                var getDataFn = paginationProps.getData;
                var savedMethod = sessionStorage.getItem('searchMethod');
                if (savedMethod === 'member_id') {
                    getDataFn =
                        (_d = searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.getDataMemberId) !== null && _d !== void 0 ? _d : paginationProps.getData;
                }
                var sessionKey = searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.sessionKey;
                var rawSearchTerm = sessionKey
                    ? sessionStorage.getItem(sessionKey)
                    : '';
                var initialSearchTerm = (_e = rawSearchTerm === null || rawSearchTerm === void 0 ? void 0 : rawSearchTerm.trim()) !== null && _e !== void 0 ? _e : '';
                dispatch(getPaginationDataIsolated(getDataFn, paginationProps.rowsPerPage, paginationProps.cacheKey || '', 1, paginationProps.onSuccess, paginationProps.onError, [], '', initialSearchTerm || undefined, paginationProps.onSearchSuccess));
            };
            var delay = (_a = currentProps.debounceDelay) !== null && _a !== void 0 ? _a : 0;
            if (delay > 0) {
                var timer_1 = setTimeout(fetchData, delay);
                return function () {
                    clearTimeout(timer_1);
                };
            }
            fetchData();
        }, [dispatch, dependency]);
        switch (currentProps.fetchType) {
            case PaginationFetchTypes.LAST_EVALUATED_KEY: {
                var paginationProps = currentProps.paginationProps, searchBarProps = currentProps.searchBarProps;
                var paginationPropsModified = __assign(__assign({}, paginationProps), { componentProps: componentProps, WrappedComponent: WrappedComponent });
                return (_jsxs(PaginationSearchProvider, { children: [searchBarProps && _jsx(SearchContainer, __assign({}, searchBarProps)), _jsx(PaginationContainer, __assign({}, paginationPropsModified))] }));
            }
            case PaginationFetchTypes.OFFSET: {
                var paginationOffsetProps = currentProps.paginationOffsetProps, searchBarProps = currentProps.searchBarProps;
                var paginationOffsetPropsModified = __assign(__assign({}, paginationOffsetProps), { componentProps: componentProps, WrappedComponent: WrappedComponent });
                return (_jsxs(PaginationSearchProvider, { children: [searchBarProps && (_jsx(SearchContainer, __assign({}, searchBarProps, { fetchType: currentProps.fetchType }))), _jsx(PaginationOffsetContainer, __assign({}, paginationOffsetPropsModified))] }));
            }
            default:
                return _jsx(_Fragment, {});
        }
    };
    return WithPaginationSearch;
};
export default withPaginationTable;
